import React, { useState } from "react";
import "../Login/Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const SignUp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const [successMessage, setSuccessMessage] = useState("");

  const { handleRegister } = useAuth();
  const navigate = useNavigate();

  const validate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!firstName.trim()) newErrors.firstName = "First name is required.";
    if (!lastName.trim()) newErrors.lastName = "Last name is required.";
    if (!emailRegex.test(email))
      newErrors.email = "Enter a valid email address.";
    if (!/^\d{10}$/.test(phoneNo))
      newErrors.phoneNo = "Phone number must be exactly 10 digits.";
    if (password.length < 6)
      newErrors.password = "Password must be at least 6 characters.";
    if (password !== confirmPassword)
      newErrors.confirmPassword = "Passwords do not match.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (validate()) {
  //     const formData = {
  //       firstName,
  //       lastName,
  //       email,
  //       phoneNo,
  //       password,
  //       confirmPassword,
  //     };

  //     const result = await handleRegister(formData);

  //     if (!result.success) {
  //       setErrors({ server: result.message });
  //     } else {
  //       navigate("/login");
  //     }
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});
    setSuccessMessage("");

    if (!validate()) return;

    const formData = {
      firstName,
      lastName,
      email,
      phoneNo,
      password,
      confirmPassword,
    };

    const result = await handleRegister(formData);

    if (!result.success) {
      setErrors({ server: result.message });
    } else {
      setSuccessMessage(
        result.message || "Account created successfully! Redirecting..."
      );

      setTimeout(() => {
        navigate("/login");
      }, 1500);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center py-5"
      style={{
        background:
          "linear-gradient(135deg,#2563eb 0%,#4f46e5 45%,#7c3aed 100%)",
      }}
    >
      <div className="container">
        <div className="row justify-content-center align-items-center">
          {/* Left Section */}

          <div className="col-lg-6 d-none d-lg-block text-white">
            <h1
              className="fw-bold mb-4"
              style={{
                fontSize: "52px",
                lineHeight: 1.2,
              }}
            >
              Join Glamira ✨
            </h1>

            <p className="fs-5 opacity-75">
              Create your account and enjoy exclusive deals, faster checkout,
              wishlist, order tracking and premium shopping experience.
            </p>

            <div className="mt-5">
              <div className="d-flex align-items-center mb-4">
                <i className="fa-solid fa-bag-shopping fs-3 me-3"></i>
                Shop Thousands of Products
              </div>

              <div className="d-flex align-items-center mb-4">
                <i className="fa-solid fa-credit-card fs-3 me-3"></i>
                Secure Payments
              </div>

              <div className="d-flex align-items-center">
                <i className="fa-solid fa-truck-fast fs-3 me-3"></i>
                Fast Delivery
              </div>
            </div>
          </div>

          {/* Signup Card */}

          <div className="col-lg-5 col-md-8">
            <div
              className="shadow-lg"
              style={{
                background: "#fff",
                borderRadius: "30px",
                padding: "40px",
              }}
            >
              <div className="text-center mb-4">
                <div
                  className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    background: "linear-gradient(135deg,#2563eb,#7c3aed)",
                  }}
                >
                  <i
                    className="fa-solid fa-user-plus"
                    style={{
                      color: "#fff",
                      fontSize: 30,
                    }}
                  ></i>
                </div>

                <h2 className="fw-bold">Create Account</h2>

                <p className="text-muted">Start your shopping journey today</p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <input
                      className="form-control"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                        setErrors((prev) => ({ ...prev, firstName: "" }));
                      }}
                      style={{
                        height: 55,
                        borderRadius: 50,
                        border: errors.firstName ? "1px solid #dc3545" : "",
                      }}
                    />
                    {errors.firstName && (
                      <small className="text-danger ms-3">
                        {errors.firstName}
                      </small>
                    )}
                  </div>

                  <div className="col-md-6 mb-3">
                    <input
                      className="form-control"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                        setErrors((prev) => ({ ...prev, lastName: "" }));
                      }}
                      style={{
                        height: 55,
                        borderRadius: 50,
                        border: errors.lastName ? "1px solid #dc3545" : "",
                      }}
                    />
                    {errors.lastName && (
                      <small className="text-danger ms-3">
                        {errors.lastName}
                      </small>
                    )}
                  </div>
                </div>

                <input
                  type="email"
                  className="form-control mb-3"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrors((prev) => ({ ...prev, email: "" }));
                  }}
                  style={{
                    height: 55,
                    borderRadius: 50,
                    border: errors.email ? "1px solid #dc3545" : "",
                  }}
                />
                {errors.email && (
                  <small className="text-danger ms-3">
                    {errors.email}
                  </small>
                )}

                <input
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]{10}"
                  className="form-control mb-3"
                  placeholder="Phone Number"
                  minLength={10}
                  maxLength={10}
                  value={phoneNo || ""}
                  onChange={(e) => {
                    // Allow only numbers, maximum 10 digits
                    const numericValue = e.target.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 10);

                    setPhoneNo(numericValue);

                    setErrors((prev) => ({
                      ...prev,
                      phoneNo: "",
                    }));
                  }}
                  required
                  style={{
                    height: 55,
                    borderRadius: 50,
                    border: errors.phoneNo ? "1px solid #dc3545" : "",
                  }}
                />

                {errors.phoneNo && (
                  <small className="text-danger ms-3">
                    {errors.phoneNo}
                  </small>
                )}

                <input
                  type="password"
                  className="form-control mb-3"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, password: "" }));
                  }}
                  style={{
                    height: 55,
                    borderRadius: 50,
                    border: errors.password ? "1px solid #dc3545" : "",
                  }}
                />

                {errors.password && (
                  <small className="text-danger ms-3">
                    {errors.password}
                  </small>
                )}

                <input
                  type="password"
                  className="form-control mb-3"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                  }}
                  style={{
                    height: 55,
                    borderRadius: 50,
                    border: errors.confirmPassword ? "1px solid #dc3545" : "",
                  }}
                />

                {errors.confirmPassword && (
                  <small className="text-danger ms-3">
                    {errors.confirmPassword}
                  </small>
                )}

                {errors.server && (
                  <div
                    className="alert alert-danger d-flex align-items-center mt-3"
                    style={{ borderRadius: "15px" }}
                  >
                    <i className="fa-solid fa-circle-exclamation me-2"></i>
                    {errors.server}
                  </div>
                )}

                {successMessage && (
                  <div
                    className="alert alert-success d-flex align-items-center mt-3"
                    style={{ borderRadius: "15px" }}
                  >
                    <i className="fa-solid fa-circle-check me-2"></i>
                    {successMessage}
                  </div>
                )}

                <button
                  className="btn w-100 text-white fw-bold"
                  type="submit"
                  style={{
                    height: 55,
                    borderRadius: 50,
                    background:
                      "linear-gradient(135deg,#2563eb,#4f46e5,#7c3aed)",
                    border: "none",
                  }}
                >
                  Create Account →
                </button>

                <div className="text-center mt-4">
                  Already have an account?
                  <Link
                    to="/login"
                    className="fw-bold ms-2 text-decoration-none"
                  >
                    Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
